export default __webpack_public_path__ + "static/media/memberBg2.8d91a688.png";